const BookmarkIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns='http://www.w3.org/2000/svg' className={className} width='14' height='16' viewBox='0 0 14 16' fill='none' data-sentry-element="svg" data-sentry-component="BookmarkIcon" data-sentry-source-file="BookmarkIcon.tsx">
    <path d='M0 16V0H14V16L7 11L0 16Z' stroke='currentColor' strokeWidth='1.5' fill='inherit' data-sentry-element="path" data-sentry-source-file="BookmarkIcon.tsx" />
  </svg>;
export default BookmarkIcon;